
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.28","height":"23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.993 12.327a6.768 6.768 0 10-7.707 0C.564 14.013.111 18.288 0 20.832a1.391 1.391 0 00.9 1.331c1.337.349 4.02.837 11.24.837s9.9-.488 11.235-.837a1.392 1.392 0 00.9-1.331c-.106-2.544-.559-6.819-8.282-8.505z"}})])
          )
        }
      }
    